import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  timeIntervals: {
    id: 'admin/promotions.form.recurrence.time-intervals',
  },
  anytime: {
    id: 'admin/promotions.form.recurrence.time-intervals.any',
  },
  specificIntervals: {
    id: 'admin/promotions.form.recurrence.time-intervals.specific',
  },
  startTime: {
    id: 'admin/promotions.form.scheduling.start-time',
  },
  endTime: {
    id: 'admin/promotions.form.scheduling.end-time',
  },
  addInterval: {
    id: 'admin/promotions.form.recurrence.time-intervals.add',
  },
  removeInterval: {
    id: 'admin/promotions.form.recurrence.time-intervals.remove',
  },

  required: {
    id: 'admin/promotions.form.validation.required',
  },
  valuesAreEqual: {
    id: 'admin/promotions.form.recurrence.time-intervals.validation.must-be-different',
  },
})
